export default {
  // Common routes
  shortlist: "/main/shortlist",
  interviewStatus: "/main/interview-status",
  dashboard: "/main/dashboard",
  settings: "/main/settings",
  talentNetwork: "/main/talent-network",
  requestAHire: "/main/request-a-hire",
  talentNetworkProfile: "/main/talent-network/:id",
  manageUsers: "/main/manage-users",
  feedback: "/main/feedback",
  holidays: "/main/holidays",
  holidaySchedule: "/main/holiday-schedule",
  workforce: "/main/workforce",
  edgeAtlas: "/main/edge-atlas",
  timesheet: "/main/timesheet",

  // Customer routes
  payroll: "/main/payroll",
  workforceDetails: "/main/details/:id",
  payrollHistory: "/main/payroll?history=true",
  editPayroll: "/main/customers/editPayroll",
  payrollDetail: "/main/payroll/detail/:id",
  timeoffLeave: "/main/timeoff/leave#Pending",
  payment: "/main/payment",
  groups: "/main/groups",
  roles: "/main/settings/roles",
  features: "/main/settings/features",
  addPaymentMethod: "/addPaymentMethod",
  talentProfile: "/main/marketplace/talent-profile/:id",
  referrals: "/main/referrals",

  // Employee routes
  paystubs: "/main/paystubs",
  edgeWallet: "/main/edge-wallet",
  timeoff: "/main/timeoff",
  timeoffRequest: "/main/timeoff/request",
  peers: "/main/peers",
  community: "https://community.onedge.co/",
  eprofile: "/main/eprofile",
  vivo: "/main/vivo",
  paySlipDetail: "/main/paystubs/:id",

  // Edge routes
  customers: "/main/customers",
  billingDev: "/main/billing-dev",
  workforcePayrolls: "/main/workforcepayrolls",
  payrollsUpload: "/main/payrollsupload",
  timeoffAdmin: "/main/timeoff/admin",
  profile: "/main/profile",

  // Chat
  chat: "/main/chat",

  // External routes
  helpSupport: "https://get.help.onedge.co/servicedesk/customer/portals",
};
